// ============================================
// 📱 APP: NVA (React App)
// 📄 FILE: src/pageChunks.js
// 🔧 PURPOSE: I caricatori dei pezzi delle pagine: un import() dinamico per
//             pagina, e webpack ne fa un file a sé (lib/lazyPage, App.tsx).
//
//             Stanno in un file JavaScript di proposito: tsconfig.json non
//             ha "module": "esnext" e non va messo, perché vale anche per le
//             funzioni in api/, che @vercel/node compila in CommonJS solo
//             quando "module" manca. TypeScript (4.9, target es2015) in un
//             .ts/.tsx rifiuterebbe import() (TS1323) e la build si
//             fermerebbe. I tipi li dà pageChunks.d.ts.
// ============================================
export const loadRestaurants = () => import('./pages/Restaurants');
export const loadExplore = () => import('./pages/Explore');
export const loadBookNow = () => import('./pages/BookNow');
export const loadCheckIn = () => import('./pages/CheckIn');
export const loadClaimBooking = () => import('./pages/ClaimBooking');
export const loadPartners = () => import('./pages/Partners');
export const loadMolaDiBari = () => import('./pages/cities/MolaDiBari');
export const loadPoliganoAMare = () => import('./pages/cities/PoliganoAMare');
export const loadMonopoli = () => import('./pages/cities/Monopoli');
export const loadBari = () => import('./pages/cities/Bari');
export const loadAlberobello = () => import('./pages/cities/Alberobello');
export const loadLocorotondo = () => import('./pages/cities/Locorotondo');
export const loadTrani = () => import('./pages/cities/Trani');
export const loadCastellanaGrotte = () => import('./pages/cities/CastellanaGrotte');
export const loadMatera = () => import('./pages/cities/Matera');
export const loadLecce = () => import('./pages/cities/Lecce');
export const loadZoosafari = () => import('./pages/cities/Zoosafari');
export const loadOstuni = () => import('./pages/cities/Ostuni');
export const loadTrips = () => import('./pages/Trips');
export const loadBeaches = () => import('./pages/Beaches');
export const loadAttractionPage = () => import('./pages/cities/AttractionPage');
export const loadMyStay = () => import('./pages/MyStay');
export const loadExtras = () => import('./pages/Extras');
export const loadExtraDetail = () => import('./pages/ExtraDetail');
export const loadExtrasCart = () => import('./pages/ExtrasCart');
export const loadLaundry = () => import('./pages/Laundry');
export const loadGroupCheckIn = () => import('./pages/GroupCheckIn');
export const loadGiftCards = () => import('./pages/GiftCards');
export const loadMyGiftCards = () => import('./pages/MyGiftCards');
export const loadRomanticEscape = () => import('./pages/RomanticEscape');
export const loadPaymentSuccess = () => import('./pages/PaymentSuccess');
export const loadParking = () => import('./pages/Parking');
export const loadTravelNotes = () => import('./pages/TravelNotes');
export const loadTravelWallet = () => import('./pages/travel-wallet');
export const loadEvents = () => import('./pages/Events');
export const loadPharmacy = () => import('./pages/Pharmacy');
export const loadAudioTourPlayer = () => import('./pages/AudioTourPlayer');
// I servizi della Home, una pagina ciascuno (lib/servicePages).
export const loadServiceRecycle = () => import('./pages/services/RecyclePage');
export const loadServiceEmergency = () => import('./pages/services/EmergencyPage');
export const loadServiceDelivery = () => import('./pages/services/DeliveryPage');
export const loadServiceExcursions = () => import('./pages/services/ExcursionsPage');
export const loadServiceExcursionPlanner = () => import('./pages/services/ExcursionPlannerPage');
export const loadServiceMassage = () => import('./pages/services/MassagePage');
export const loadServiceRentCar = () => import('./pages/services/RentCarPage');
export const loadServiceRentBike = () => import('./pages/services/RentBikePage');
export const loadServiceGame = () => import('./pages/services/GamePage');
export const loadServiceTarallo = () => import('./pages/services/TaralloGamePage');
export const loadServiceSapori = () => import('./pages/services/SaporiGamePage');
export const loadServicePolpo = () => import('./pages/services/PolpoGamePage');
// Il pannello di prova della barra di stato (solo per il proprietario).
export const loadStatusBarProbe = () => import('./components/statusBarProbe/StatusBarProbe');
